module.exports = __webpack_public_path__ + "static/HorseBdos-48bb24540bcb1edc75a43d63f73ca196.png";